import { useCallback, useEffect, useState } from 'react'
import {
  Backdrop,
  Button,
  Checkbox,
  CircularProgress,
  FormControlLabel,
  Grid,
  makeStyles
} from '@material-ui/core'
import SaveOrCancelButtons from '../../components/saveOrCancelButtons'
import { useDispatch } from 'react-redux'
import { setProvider } from '../../redux/features/providerSlice'
import { useHistory } from 'react-router-dom'
import {
  createProviderConditionsApprovals,
  getProviderConditions
} from '../../api/providerConditions.service'

const useStyles = makeStyles((theme) => ({
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff'
  },
  title: {
    justifySelf: 'end',
    margin: '-5px 15px 20px 5px'
  }
}))

const AcceptDocuments = (props) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()

  const provider = props.provider
  const handleClose = props.onClose

  const [loading, setLoading] = useState(false)
  const [isAllAccepted, setIsAllAccepted] = useState(false)

  const [stateForm, setStateForm] = useState([])

  const getData = useCallback(() => {
    setLoading(true)
    getProviderConditions(provider.id).then((result) => {
      setStateForm(result.data.filter((condition) => !condition.isAccepted))
      setLoading(false)
    })
  }, [provider.id])

  useEffect(() => {
    if (provider !== undefined && provider !== null && provider !== {}) {
      getData()
    }
  }, [provider, getData])

  const handleInputChange = (event, condition) => {
    const target = event.target
    const targetValue = target.type === 'checkbox' ? target.checked : target.value
    condition.isAccepted =
      isNaN(targetValue) || targetValue === '' || typeof targetValue === 'boolean'
        ? targetValue
        : +targetValue
    const conditions = [...stateForm.filter((c) => c.id !== condition.id), condition].sort(
      (previous, current) => previous.id - current.id
    )
    setStateForm(conditions)
    setIsAllAccepted(conditions.every((condition) => condition.isAccepted))
  }

  const handleAccept = () => {
    if (!isAllAccepted) return
    createProviderConditionsApprovals({ providerId: provider.id }).then(() => {
      dispatch(setProvider(provider))
      history.push('/')
    })
  }

  return (
    <div>
      <Grid container direction="column">
        <Grid item className={classes.title}>
          <h2>Aceptar términos y condiciones: {provider.name}</h2>
          <p className="mb-0">
            Para continuar debes de descargar, leer y aceptar los siguientes documentos:{' '}
          </p>
        </Grid>
        <Grid item>
          <Grid container direction="row" spacing={2}>
            {stateForm.map((condition, index) => (
              <Grid item xs={12} key={`document-${index}`}>
                <Grid item xs={12}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        name="isManualAccepted"
                        color="secondary"
                        checked={condition.isAccepted}
                        required
                        onChange={(event) => handleInputChange(event, condition)}
                      />
                    }
                    label={`He leído y acepto los términos y condiciones del documento ${condition.spanishName} (${condition.englishName}).`}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Button
                    variant="contained"
                    size="small"
                    className="mr-2 mb-2"
                    target="_blank"
                    href={condition.englishDocumentUrl}
                  >
                    {condition.englishName}
                  </Button>
                  <Button
                    variant="contained"
                    size="small"
                    className="mr-2 mb-2"
                    target="_blank"
                    href={condition.spanishDocumentUrl}
                  >
                    {condition.spanishName}
                  </Button>
                </Grid>
              </Grid>
            ))}
            {!isAllAccepted && (
              <p className="mb-0 text-primary">* Debes aceptar todos los documentos</p>
            )}
            <SaveOrCancelButtons onSave={handleAccept} onCancel={handleClose} loading={loading} />
          </Grid>
        </Grid>
      </Grid>
      <Backdrop className={classes.backdrop} open={loading} onClick={handleClose}>
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  )
}

export default AcceptDocuments
